import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import styles from './error-state.module.css';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  title = '出错了',
  message = '加载失败，请稍后重试',
  onRetry,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <AlertCircle size={48} />
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.message}>{message}</p>
      {onRetry && (
        <button className={styles.retryBtn} onClick={onRetry}>
          <RefreshCw size={16} />
          重新加载
        </button>
      )}
    </div>
  );
};

export default ErrorState;
